// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Re-export from Figma using the "theming-export-figma-tokens" skill

export const TOKENS = {
  primitives: {
    colorPrimaryBlue50: 'var(--color-primary-blue-50)',
    colorPrimaryBlue100: 'var(--color-primary-blue-100)',
    colorPrimaryBlue200: 'var(--color-primary-blue-200)',
    colorPrimaryBlue300: 'var(--color-primary-blue-300)',
    colorPrimaryBlue400: 'var(--color-primary-blue-400)',
    colorPrimaryBlue500: 'var(--color-primary-blue-500)',
    colorPrimaryBlue600: 'var(--color-primary-blue-600)',
    colorPrimaryBlue700: 'var(--color-primary-blue-700)',
    colorPrimaryBlue800: 'var(--color-primary-blue-800)',
    colorPrimaryBlue900: 'var(--color-primary-blue-900)',
    colorPrimaryRed50: 'var(--color-primary-red-50)',
    colorPrimaryRed100: 'var(--color-primary-red-100)',
    colorPrimaryRed200: 'var(--color-primary-red-200)',
    colorPrimaryRed300: 'var(--color-primary-red-300)',
    colorPrimaryRed400: 'var(--color-primary-red-400)',
    colorPrimaryRed500: 'var(--color-primary-red-500)',
    colorPrimaryRed600: 'var(--color-primary-red-600)',
    colorPrimaryRed700: 'var(--color-primary-red-700)',
    colorPrimaryRed800: 'var(--color-primary-red-800)',
    colorPrimaryRed900: 'var(--color-primary-red-900)',
    colorPrimaryGreen50: 'var(--color-primary-green-50)',
    colorPrimaryGreen100: 'var(--color-primary-green-100)',
    colorPrimaryGreen200: 'var(--color-primary-green-200)',
    colorPrimaryGreen300: 'var(--color-primary-green-300)',
    colorPrimaryGreen400: 'var(--color-primary-green-400)',
    colorPrimaryGreen500: 'var(--color-primary-green-500)',
    colorPrimaryGreen600: 'var(--color-primary-green-600)',
    colorPrimaryGreen700: 'var(--color-primary-green-700)',
    colorPrimaryGreen800: 'var(--color-primary-green-800)',
    colorPrimaryGreen900: 'var(--color-primary-green-900)',
    colorPrimaryOrange50: 'var(--color-primary-orange-50)',
    colorPrimaryOrange100: 'var(--color-primary-orange-100)',
    colorPrimaryOrange200: 'var(--color-primary-orange-200)',
    colorPrimaryOrange300: 'var(--color-primary-orange-300)',
    colorPrimaryOrange400: 'var(--color-primary-orange-400)',
    colorPrimaryOrange500: 'var(--color-primary-orange-500)',
    colorPrimaryOrange600: 'var(--color-primary-orange-600)',
    colorPrimaryOrange700: 'var(--color-primary-orange-700)',
    colorPrimaryOrange800: 'var(--color-primary-orange-800)',
    colorPrimaryOrange900: 'var(--color-primary-orange-900)',
    colorPrimaryGrayscale50: 'var(--color-primary-grayscale-50)',
    colorPrimaryGrayscale100: 'var(--color-primary-grayscale-100)',
    colorPrimaryGrayscale200: 'var(--color-primary-grayscale-200)',
    colorPrimaryGrayscale300: 'var(--color-primary-grayscale-300)',
    colorPrimaryGrayscale400: 'var(--color-primary-grayscale-400)',
    colorPrimaryGrayscale500: 'var(--color-primary-grayscale-500)',
    colorPrimaryGrayscale600: 'var(--color-primary-grayscale-600)',
    colorPrimaryGrayscale700: 'var(--color-primary-grayscale-700)',
    colorPrimaryGrayscale750: 'var(--color-primary-grayscale-750)',
    colorPrimaryGrayscale800: 'var(--color-primary-grayscale-800)',
    colorPrimaryGrayscale850: 'var(--color-primary-grayscale-850)',
    colorPrimaryGrayscale900: 'var(--color-primary-grayscale-900)',
    colorPrimaryGrayscale950: 'var(--color-primary-grayscale-950)',
    colorPrimaryGrayscale1000: 'var(--color-primary-grayscale-1000)',
    colorPrimaryGrayscale1050: 'var(--color-primary-grayscale-1050)',
    colorProductDrs50: 'var(--color-product-DRS-50)',
    colorProductDrs100: 'var(--color-product-DRS-100)',
    colorProductDrs200: 'var(--color-product-DRS-200)',
    colorProductDrs300: 'var(--color-product-DRS-300)',
    colorProductDrs400: 'var(--color-product-DRS-400)',
    colorProductDrs500: 'var(--color-product-DRS-500)',
    colorProductDrs600: 'var(--color-product-DRS-600)',
    colorProductDrs700: 'var(--color-product-DRS-700)',
    colorProductDrs800: 'var(--color-product-DRS-800)',
    colorProductDrs900: 'var(--color-product-DRS-900)',
    colorProductVdr50: 'var(--color-product-VDR-50)',
    colorProductVdr100: 'var(--color-product-VDR-100)',
    colorProductVdr200: 'var(--color-product-VDR-200)',
    colorProductVdr300: 'var(--color-product-VDR-300)',
    colorProductVdr400: 'var(--color-product-VDR-400)',
    colorProductVdr500: 'var(--color-product-VDR-500)',
    colorProductVdr600: 'var(--color-product-VDR-600)',
    colorProductVdr700: 'var(--color-product-VDR-700)',
    colorProductVdr800: 'var(--color-product-VDR-800)',
    colorProductVdr900: 'var(--color-product-VDR-900)',
    colorProductInv50: 'var(--color-product-INV-50)',
    colorProductInv100: 'var(--color-product-INV-100)',
    colorProductInv200: 'var(--color-product-INV-200)',
    colorProductInv300: 'var(--color-product-INV-300)',
    colorProductInv400: 'var(--color-product-INV-400)',
    colorProductInv500: 'var(--color-product-INV-500)',
    colorProductInv600: 'var(--color-product-INV-600)',
    colorProductInv700: 'var(--color-product-INV-700)',
    colorProductInv800: 'var(--color-product-INV-800)',
    colorProductInv900: 'var(--color-product-INV-900)',
    colorProductEvc50: 'var(--color-product-EVC-50)',
    colorProductEvc100: 'var(--color-product-EVC-100)',
    colorProductEvc200: 'var(--color-product-EVC-200)',
    colorProductEvc300: 'var(--color-product-EVC-300)',
    colorProductEvc400: 'var(--color-product-EVC-400)',
    colorProductEvc500: 'var(--color-product-EVC-500)',
    colorProductEvc600: 'var(--color-product-EVC-600)',
    colorProductEvc700: 'var(--color-product-EVC-700)',
    colorProductEvc800: 'var(--color-product-EVC-800)',
    colorProductEvc900: 'var(--color-product-EVC-900)',
    colorProduct17g50: 'var(--color-product-17G-50)',
    colorProduct17g100: 'var(--color-product-17G-100)',
    colorProduct17g200: 'var(--color-product-17G-200)',
    colorProduct17g300: 'var(--color-product-17G-300)',
    colorProduct17g400: 'var(--color-product-17G-400)',
    colorProduct17g500: 'var(--color-product-17G-500)',
    colorProduct17g600: 'var(--color-product-17G-600)',
    colorProduct17g700: 'var(--color-product-17G-700)',
    colorProduct17g800: 'var(--color-product-17G-800)',
    colorProduct17g900: 'var(--color-product-17G-900)',
    colorProductAlc50: 'var(--color-product-ALC-50)',
    colorProductAlc100: 'var(--color-product-ALC-100)',
    colorProductAlc200: 'var(--color-product-ALC-200)',
    colorProductAlc300: 'var(--color-product-ALC-300)',
    colorProductAlc400: 'var(--color-product-ALC-400)',
    colorProductAlc500: 'var(--color-product-ALC-500)',
    colorProductAlc600: 'var(--color-product-ALC-600)',
    colorProductAlc700: 'var(--color-product-ALC-700)',
    colorProductAlc800: 'var(--color-product-ALC-800)',
    colorProductAlc900: 'var(--color-product-ALC-900)',
    colorProductVrs50: 'var(--color-product-VRS-50)',
    colorProductVrs100: 'var(--color-product-VRS-100)',
    colorProductVrs200: 'var(--color-product-VRS-200)',
    colorProductVrs300: 'var(--color-product-VRS-300)',
    colorProductVrs400: 'var(--color-product-VRS-400)',
    colorProductVrs500: 'var(--color-product-VRS-500)',
    colorProductVrs600: 'var(--color-product-VRS-600)',
    colorProductVrs700: 'var(--color-product-VRS-700)',
    colorProductVrs800: 'var(--color-product-VRS-800)',
    colorProductVrs900: 'var(--color-product-VRS-900)',
    colorProductFin50: 'var(--color-product-FIN-50)',
    colorProductFin100: 'var(--color-product-FIN-100)',
    colorProductFin200: 'var(--color-product-FIN-200)',
    colorProductFin300: 'var(--color-product-FIN-300)',
    colorProductFin400: 'var(--color-product-FIN-400)',
    colorProductFin500: 'var(--color-product-FIN-500)',
    colorProductFin600: 'var(--color-product-FIN-600)',
    colorProductFin700: 'var(--color-product-FIN-700)',
    colorProductFin800: 'var(--color-product-FIN-800)',
    colorProductFin900: 'var(--color-product-FIN-900)',
    colorProductRes50: 'var(--color-product-RES-50)',
    colorProductRes100: 'var(--color-product-RES-100)',
    colorProductRes200: 'var(--color-product-RES-200)',
    colorProductRes300: 'var(--color-product-RES-300)',
    colorProductRes400: 'var(--color-product-RES-400)',
    colorProductRes500: 'var(--color-product-RES-500)',
    colorProductRes600: 'var(--color-product-RES-600)',
    colorProductRes700: 'var(--color-product-RES-700)',
    colorProductRes800: 'var(--color-product-RES-800)',
    colorProductRes900: 'var(--color-product-RES-900)',
    colorProductLos50: 'var(--color-product-LOS-50)',
    colorProductLos100: 'var(--color-product-LOS-100)',
    colorProductLos200: 'var(--color-product-LOS-200)',
    colorProductLos300: 'var(--color-product-LOS-300)',
    colorProductLos400: 'var(--color-product-LOS-400)',
    colorProductLos500: 'var(--color-product-LOS-500)',
    colorProductLos600: 'var(--color-product-LOS-600)',
    colorProductLos700: 'var(--color-product-LOS-700)',
    colorProductLos800: 'var(--color-product-LOS-800)',
    colorProductLos900: 'var(--color-product-LOS-900)',
    colorProductOrb50: 'var(--color-product-ORB-50)',
    colorProductOrb100: 'var(--color-product-ORB-100)',
    colorProductOrb200: 'var(--color-product-ORB-200)',
    colorProductOrb300: 'var(--color-product-ORB-300)',
    colorProductOrb400: 'var(--color-product-ORB-400)',
    colorProductOrb500: 'var(--color-product-ORB-500)',
    colorProductOrb600: 'var(--color-product-ORB-600)',
    colorProductOrb700: 'var(--color-product-ORB-700)',
    colorProductOrb800: 'var(--color-product-ORB-800)',
    colorProductOrb900: 'var(--color-product-ORB-900)',
    colorProductAbs400: 'var(--color-product-ABS-400)',
    colorProductAbs500: 'var(--color-product-ABS-500)',
    colorProductAbs600: 'var(--color-product-ABS-600)',
    colorProductHyc400: 'var(--color-product-HYC-400)',
    colorProductHyc500: 'var(--color-product-HYC-500)',
    colorProductHyc600: 'var(--color-product-HYC-600)',
    colorProductIgc400: 'var(--color-product-IGC-400)',
    colorProductIgc500: 'var(--color-product-IGC-500)',
    colorProductIgc600: 'var(--color-product-IGC-600)',
    colorProductEm400: 'var(--color-product-EM-400)',
    colorProductEm500: 'var(--color-product-EM-500)',
    colorProductEm600: 'var(--color-product-EM-600)',
    colorProductCap400: 'var(--color-product-CAP-400)',
    colorProductCap500: 'var(--color-product-CAP-500)',
    colorProductCap600: 'var(--color-product-CAP-600)',
    colorProductSwb400: 'var(--color-product-SWB-400)',
    colorProductSwb500: 'var(--color-product-SWB-500)',
    colorProductSwb600: 'var(--color-product-SWB-600)',
    colorProductCfr400: 'var(--color-product-CFR-400)',
    colorProductCfr500: 'var(--color-product-CFR-500)',
    colorProductCfr600: 'var(--color-product-CFR-600)',
    colorFoundationsBlack5: 'var(--color-foundations-black-5)',
    colorFoundationsBlack10: 'var(--color-foundations-black-10)',
    colorFoundationsBlack15: 'var(--color-foundations-black-15)',
    colorFoundationsBlack20: 'var(--color-foundations-black-20)',
    colorFoundationsBlack30: 'var(--color-foundations-black-30)',
    colorFoundationsBlack40: 'var(--color-foundations-black-40)',
    colorFoundationsBlack50: 'var(--color-foundations-black-50)',
    colorFoundationsBlack60: 'var(--color-foundations-black-60)',
    colorFoundationsBlack70: 'var(--color-foundations-black-70)',
    colorFoundationsBlack80: 'var(--color-foundations-black-80)',
    colorFoundationsBlack90: 'var(--color-foundations-black-90)',
    colorFoundationsBlack100: 'var(--color-foundations-black-100)',
    colorFoundationsWhite5: 'var(--color-foundations-white-5)',
    colorFoundationsWhite10: 'var(--color-foundations-white-10)',
    colorFoundationsWhite20: 'var(--color-foundations-white-20)',
    colorFoundationsWhite30: 'var(--color-foundations-white-30)',
    colorFoundationsWhite40: 'var(--color-foundations-white-40)',
    colorFoundationsWhite50: 'var(--color-foundations-white-50)',
    colorFoundationsWhite60: 'var(--color-foundations-white-60)',
    colorFoundationsWhite70: 'var(--color-foundations-white-70)',
    colorFoundationsWhite80: 'var(--color-foundations-white-80)',
    colorFoundationsWhite90: 'var(--color-foundations-white-90)',
    colorFoundationsWhite100: 'var(--color-foundations-white-100)',
    colorFoundationsBlue5: 'var(--color-foundations-blue-5)',
    colorFoundationsBlue10: 'var(--color-foundations-blue-10)',
    colorFoundationsBlue20: 'var(--color-foundations-blue-20)',
    colorFoundationsBlue30: 'var(--color-foundations-blue-30)',
    colorFoundationsBlue40: 'var(--color-foundations-blue-40)',
    colorFoundationsBlue50: 'var(--color-foundations-blue-50)',
    colorFoundationsBlue60: 'var(--color-foundations-blue-60)',
    colorFoundationsBlue70: 'var(--color-foundations-blue-70)',
    colorFoundationsBlue80: 'var(--color-foundations-blue-80)',
    colorFoundationsBlue90: 'var(--color-foundations-blue-90)',
    colorFoundationsBlue100: 'var(--color-foundations-blue-100)',
    colorFoundationsRed5: 'var(--color-foundations-red-5)',
    colorFoundationsRed10: 'var(--color-foundations-red-10)',
    colorFoundationsRed20: 'var(--color-foundations-red-20)',
    colorFoundationsRed30: 'var(--color-foundations-red-30)',
    colorFoundationsRed40: 'var(--color-foundations-red-40)',
    colorFoundationsRed50: 'var(--color-foundations-red-50)',
    colorFoundationsRed60: 'var(--color-foundations-red-60)',
    colorFoundationsRed70: 'var(--color-foundations-red-70)',
    colorFoundationsRed80: 'var(--color-foundations-red-80)',
    colorFoundationsRed90: 'var(--color-foundations-red-90)',
    colorFoundationsRed100: 'var(--color-foundations-red-100)',
    colorFoundationsGreen5: 'var(--color-foundations-green-5)',
    colorFoundationsGreen10: 'var(--color-foundations-green-10)',
    colorFoundationsGreen20: 'var(--color-foundations-green-20)',
    colorFoundationsGreen30: 'var(--color-foundations-green-30)',
    colorFoundationsGreen40: 'var(--color-foundations-green-40)',
    colorFoundationsGreen50: 'var(--color-foundations-green-50)',
    colorFoundationsGreen60: 'var(--color-foundations-green-60)',
    colorFoundationsGreen70: 'var(--color-foundations-green-70)',
    colorFoundationsGreen80: 'var(--color-foundations-green-80)',
    colorFoundationsGreen90: 'var(--color-foundations-green-90)',
    colorFoundationsGreen100: 'var(--color-foundations-green-100)',
    colorFoundationsOrange5: 'var(--color-foundations-orange-5)',
    colorFoundationsOrange10: 'var(--color-foundations-orange-10)',
    colorFoundationsOrange20: 'var(--color-foundations-orange-20)',
    colorFoundationsOrange30: 'var(--color-foundations-orange-30)',
    colorFoundationsOrange40: 'var(--color-foundations-orange-40)',
    colorFoundationsOrange50: 'var(--color-foundations-orange-50)',
    colorFoundationsOrange60: 'var(--color-foundations-orange-60)',
    colorFoundationsOrange70: 'var(--color-foundations-orange-70)',
    colorFoundationsOrange80: 'var(--color-foundations-orange-80)',
    colorFoundationsOrange90: 'var(--color-foundations-orange-90)',
    colorFoundationsOrange100: 'var(--color-foundations-orange-100)',
    colorOtherFilePng: 'var(--color-other-file-png)',
    colorOtherFilePngHover: 'var(--color-other-file-png-hover)',
    colorOtherFileJpg: 'var(--color-other-file-jpg)',
    colorOtherFileJpgHover: 'var(--color-other-file-jpg-hover)',
    colorOtherFileTiff: 'var(--color-other-file-tiff)',
    colorOtherFileTiffHover: 'var(--color-other-file-tiff-hover)',
    colorOtherFileFolder: 'var(--color-other-file-folder)',
    colorOtherFileFolderHover: 'var(--color-other-file-folder-hover)',
    colorOtherFileImage: 'var(--color-other-file-image)',
    colorOtherFilePpt: 'var(--color-other-file-ppt)',
    colorOtherFilePptHover: 'var(--color-other-file-ppt-hover)',
    colorOtherFileStaging: 'var(--color-other-file-staging)',
    colorOtherFileStagingHover: 'var(--color-other-file-staging-hover)',
    colorOtherFileArchive: 'var(--color-other-file-archive)',
    colorOtherFileArchiveHover: 'var(--color-other-file-archive-hover)',
    colorOtherFileAudio: 'var(--color-other-file-audio)',
    colorOtherFileAudioHover: 'var(--color-other-file-audio-hover)',
    colorOtherFilePdf: 'var(--color-other-file-pdf)',
    colorOtherFilePdfHover: 'var(--color-other-file-pdf-hover)',
    colorOtherFileImageHover: 'var(--color-other-file-image-hover)',
    colorOtherFileVideo: 'var(--color-other-file-video)',
    colorOtherFileVideoHover: 'var(--color-other-file-video-hover)',
    colorOtherFileCsv: 'var(--color-other-file-csv)',
    colorOtherFileCsvHover: 'var(--color-other-file-csv-hover)',
    colorOtherFileCdi: 'var(--color-other-file-cdi)',
    colorOtherFileCdiHover: 'var(--color-other-file-cdi-hover)',
    colorOtherFileXml: 'var(--color-other-file-xml)',
    colorOtherFileXmlHover: 'var(--color-other-file-xml-hover)',
    colorOtherFileXls: 'var(--color-other-file-xls)',
    colorOtherFileXlsHover: 'var(--color-other-file-xls-hover)',
    colorOtherFileDoc: 'var(--color-other-file-doc)',
    colorOtherFileDocHover: 'var(--color-other-file-doc-hover)',
    colorOtherFileTxt: 'var(--color-other-file-txt)',
    colorOtherFileTxtHover: 'var(--color-other-file-txt-hover)',
    colorOtherAccountAssetManager10b: 'var(--color-other-account-asset-manager-10b)',
    colorOtherAccountAssetManager10b35b: 'var(--color-other-account-asset-manager-10b-35b)',
    colorOtherAccountAssetManager25b50b: 'var(--color-other-account-asset-manager-25b-50b)',
    colorOtherAccountAssetManager50b100: 'var(--color-other-account-asset-manager-50b-100)',
    colorOtherAccountAssetManager100b500: 'var(--color-other-account-asset-manager-100b-500)',
    colorOtherAccountBrokerDealer: 'var(--color-other-account-broker-dealer)',
    colorOtherAccountPrivateEquity: 'var(--color-other-account-private-equity)',
    colorOtherAccountBankDepository: 'var(--color-other-account-bank-depository)',
    colorOtherAccountHedgeFund: 'var(--color-other-account-hedge-fund)',
    colorOtherAccountPensionFund: 'var(--color-other-account-pension-fund)',
    colorOtherAccountInsuranceCompany: 'var(--color-other-account-insurance-company)',
    colorOtherAccountFamilyOffice: 'var(--color-other-account-family-office)',
    colorOtherAccountCorporate: 'var(--color-other-account-corporate)',
    colorOtherAccountAdvisor: 'var(--color-other-account-advisor)',
    colorOtherAccountEndowmentFoundation: 'var(--color-other-account-endowment-foundation)',
    colorOtherAccountReit: 'var(--color-other-account-reit)',
    colorOtherAccountRetailInvestor: 'var(--color-other-account-retail-investor)',
    colorOtherAccountSovereignWealthFund: 'var(--color-other-account-sovereign-wealth-fund)',
    colorOtherAccountGovernmentAgency: 'var(--color-other-account-government-agency)',
    colorOtherAccountConsultant: 'var(--color-other-account-consultant)',
    colorOtherAccountAccountant: 'var(--color-other-account-accountant)',
    colorOtherAccountCounsel: 'var(--color-other-account-counsel)',
    colorOtherAccountNrsro: 'var(--color-other-account-nrsro)',
    colorOtherAccountMedia: 'var(--color-other-account-media)',
    colorOtherAccountTrustee: 'var(--color-other-account-trustee)',
    colorOtherAccountVentureCapital: 'var(--color-other-account-venture-capital)',
    colorOtherAccountOther: 'var(--color-other-account-other)',
    colorOtherAccountPrivateBank: 'var(--color-other-account-private-bank)',
    colorOtherAccountMutualFund: 'var(--color-other-account-mutual-fund)',
    colorOtherAccountPrivateWealthManager: 'var(--color-other-account-private-wealth-manager)',
    colorOtherAccountDiversifiedFinancialServices: 'var(--color-other-account-diversified-financial-services)',
    colorOtherAccountCreditUnion: 'var(--color-other-account-credit-union)',
    colorOtherCountryAfghanistan: 'var(--color-other-country-afghanistan)',
    colorOtherCountryAustria: 'var(--color-other-country-austria)',
    colorOtherCountryAlbania: 'var(--color-other-country-albania)',
    colorOtherCountryAlgeria: 'var(--color-other-country-algeria)',
    colorOtherCountryAndorra: 'var(--color-other-country-andorra)',
    colorOtherCountryAngola: 'var(--color-other-country-angola)',
    colorOtherCountryAntiguaAndBarbuda: 'var(--color-other-country-antigua-and-barbuda)',
    colorOtherCountryArgentina: 'var(--color-other-country-argentina)',
    colorOtherCountryArmenia: 'var(--color-other-country-armenia)',
    colorOtherCountryAustralia: 'var(--color-other-country-australia)',
    colorOtherCountryAzerbaijan: 'var(--color-other-country-azerbaijan)',
    colorOtherCountryBahamas: 'var(--color-other-country-bahamas)',
    colorOtherCountryBahrain: 'var(--color-other-country-bahrain)',
    colorOtherCountryBangladesh: 'var(--color-other-country-bangladesh)',
    colorOtherCountryBarbados: 'var(--color-other-country-barbados)',
    colorOtherCountryBelarus: 'var(--color-other-country-belarus)',
    colorOtherCountryBelgium: 'var(--color-other-country-belgium)',
    colorOtherCountryBelize: 'var(--color-other-country-belize)',
    colorOtherCountryBenin: 'var(--color-other-country-benin)',
    colorOtherCountryBhutan: 'var(--color-other-country-bhutan)',
    colorOtherCountryBolivia: 'var(--color-other-country-bolivia)',
    colorOtherCountryBosniaAndHerzegovina: 'var(--color-other-country-bosnia-and-herzegovina)',
    colorOtherCountryBotswana: 'var(--color-other-country-botswana)',
    colorOtherCountryBrazil: 'var(--color-other-country-brazil)',
    colorOtherCountryBrunei: 'var(--color-other-country-brunei)',
    colorOtherCountryBulgaria: 'var(--color-other-country-bulgaria)',
    colorOtherCountryBurkinaFaso: 'var(--color-other-country-burkina-faso)',
    colorOtherCountryBurundi: 'var(--color-other-country-burundi)',
    colorOtherCountryCambodia: 'var(--color-other-country-cambodia)',
    colorOtherCountryCameroon: 'var(--color-other-country-cameroon)',
    colorOtherCountryCanada: 'var(--color-other-country-canada)',
    colorOtherCountryCapeVerde: 'var(--color-other-country-cape-verde)',
    colorOtherCountryCentralAfricanRepublic: 'var(--color-other-country-central-african-republic)',
    colorOtherCountryChad: 'var(--color-other-country-chad)',
    colorOtherCountryChile: 'var(--color-other-country-chile)',
    colorOtherCountryChina: 'var(--color-other-country-china)',
    colorOtherCountryColombia: 'var(--color-other-country-colombia)',
    colorOtherCountryComoros: 'var(--color-other-country-comoros)',
    colorOtherCountryCongo: 'var(--color-other-country-congo)',
    colorOtherCountryCostaRica: 'var(--color-other-country-costa-rica)',
    colorOtherCountryCroatia: 'var(--color-other-country-croatia)',
    colorOtherCountryCuba: 'var(--color-other-country-cuba)',
    colorOtherCountryCyprus: 'var(--color-other-country-cyprus)',
    colorOtherCountryCzechRepublic: 'var(--color-other-country-czech-republic)',
    colorOtherCountryDemocraticRepublicOfTheCongo: 'var(--color-other-country-democratic-republic-of-the-congo)',
    colorOtherCountryDenmark: 'var(--color-other-country-denmark)',
    colorOtherCountryDjibouti: 'var(--color-other-country-djibouti)',
    colorOtherCountryDominica: 'var(--color-other-country-dominica)',
    colorOtherCountryDominicanRepublic: 'var(--color-other-country-dominican-republic)',
    colorOtherCountryEcuador: 'var(--color-other-country-ecuador)',
    colorOtherCountryEgypt: 'var(--color-other-country-egypt)',
    colorOtherCountryElSalvador: 'var(--color-other-country-el-salvador)',
    colorOtherCountryEquatorialGuinea: 'var(--color-other-country-equatorial-guinea)',
    colorOtherCountryEritrea: 'var(--color-other-country-eritrea)',
    colorOtherCountryEstonia: 'var(--color-other-country-estonia)',
    colorOtherCountryEswatini: 'var(--color-other-country-eswatini)',
    colorOtherCountryEthiopia: 'var(--color-other-country-ethiopia)',
    colorOtherCountryFiji: 'var(--color-other-country-fiji)',
    colorOtherCountryFinland: 'var(--color-other-country-finland)',
    colorOtherCountryFrance: 'var(--color-other-country-france)',
    colorOtherCountryGabon: 'var(--color-other-country-gabon)',
    colorOtherCountryGambia: 'var(--color-other-country-gambia)',
    colorOtherCountryGeorgia: 'var(--color-other-country-georgia)',
    colorOtherCountryGermany: 'var(--color-other-country-germany)',
    colorOtherCountryGhana: 'var(--color-other-country-ghana)',
    colorOtherCountryGreece: 'var(--color-other-country-greece)',
    colorOtherCountryGrenada: 'var(--color-other-country-grenada)',
    colorOtherCountryGuatemala: 'var(--color-other-country-guatemala)',
    colorOtherCountryGuinea: 'var(--color-other-country-guinea)',
    colorOtherCountryGuineaBissau: 'var(--color-other-country-guinea-bissau)',
    colorOtherCountryGuyana: 'var(--color-other-country-guyana)',
    colorOtherCountryHaiti: 'var(--color-other-country-haiti)',
    colorOtherCountryHonduras: 'var(--color-other-country-honduras)',
    colorOtherCountryHungary: 'var(--color-other-country-hungary)',
    colorOtherCountryIceland: 'var(--color-other-country-iceland)',
    colorOtherCountryIndia: 'var(--color-other-country-india)',
    colorOtherCountryIndonesia: 'var(--color-other-country-indonesia)',
    colorOtherCountryIran: 'var(--color-other-country-iran)',
    colorOtherCountryIraq: 'var(--color-other-country-iraq)',
    colorOtherCountryIreland: 'var(--color-other-country-ireland)',
    colorOtherCountryIsrael: 'var(--color-other-country-israel)',
    colorOtherCountryItaly: 'var(--color-other-country-italy)',
    colorOtherCountryJamaica: 'var(--color-other-country-jamaica)',
    colorOtherCountryJapan: 'var(--color-other-country-japan)',
    colorOtherCountryJordan: 'var(--color-other-country-jordan)',
    colorOtherCountryKazakhstan: 'var(--color-other-country-kazakhstan)',
    colorOtherCountryKenya: 'var(--color-other-country-kenya)',
    colorOtherCountryKiribati: 'var(--color-other-country-kiribati)',
    colorOtherCountryKuwait: 'var(--color-other-country-kuwait)',
    colorOtherCountryLaos: 'var(--color-other-country-laos)',
    colorOtherCountryLatvia: 'var(--color-other-country-latvia)',
    colorOtherCountryLebanon: 'var(--color-other-country-lebanon)',
    colorOtherCountryLesotho: 'var(--color-other-country-lesotho)',
    colorOtherCountryLiberia: 'var(--color-other-country-liberia)',
    colorOtherCountryLibya: 'var(--color-other-country-libya)',
    colorOtherCountryLiechtenstein: 'var(--color-other-country-liechtenstein)',
    colorOtherCountryLithuania: 'var(--color-other-country-lithuania)',
    colorOtherCountryLuxembourg: 'var(--color-other-country-luxembourg)',
    colorOtherCountryMadagascar: 'var(--color-other-country-madagascar)',
    colorOtherCountryMalawi: 'var(--color-other-country-malawi)',
    colorOtherCountryMalaysia: 'var(--color-other-country-malaysia)',
    colorOtherCountryMaldives: 'var(--color-other-country-maldives)',
    colorOtherCountryMali: 'var(--color-other-country-mali)',
    colorOtherCountryMalta: 'var(--color-other-country-malta)',
    colorOtherCountryMarshallIslands: 'var(--color-other-country-marshall-islands)',
    colorOtherCountryMauritania: 'var(--color-other-country-mauritania)',
    colorOtherCountryMauritius: 'var(--color-other-country-mauritius)',
    colorOtherCountryMexico: 'var(--color-other-country-mexico)',
    colorOtherCountryMicronesia: 'var(--color-other-country-micronesia)',
    colorOtherCountryMoldova: 'var(--color-other-country-moldova)',
    colorOtherCountryMonaco: 'var(--color-other-country-monaco)',
    colorOtherCountryMongolia: 'var(--color-other-country-mongolia)',
    colorOtherCountryMontenegro: 'var(--color-other-country-montenegro)',
    colorOtherCountryMorocco: 'var(--color-other-country-morocco)',
    colorOtherCountryMozambique: 'var(--color-other-country-mozambique)',
    colorOtherCountryMyanmar: 'var(--color-other-country-myanmar)',
    colorOtherCountryNamibia: 'var(--color-other-country-namibia)',
    colorOtherCountryNauru: 'var(--color-other-country-nauru)',
    colorOtherCountryNepal: 'var(--color-other-country-nepal)',
    colorOtherCountryNetherlands: 'var(--color-other-country-netherlands)',
    colorOtherCountryNewZealand: 'var(--color-other-country-new-zealand)',
    colorOtherCountryNicaragua: 'var(--color-other-country-nicaragua)',
    colorOtherCountryNorthKorea: 'var(--color-other-country-north-korea)',
    colorOtherCountryNorway: 'var(--color-other-country-norway)',
    colorOtherCountryOman: 'var(--color-other-country-oman)',
    colorOtherCountryPakistan: 'var(--color-other-country-pakistan)',
    colorOtherCountryPalau: 'var(--color-other-country-palau)',
    colorOtherCountryPalestine: 'var(--color-other-country-palestine)',
    colorOtherCountryPanama: 'var(--color-other-country-panama)',
    colorOtherCountryPapuaNewGuinea: 'var(--color-other-country-papua-new-guinea)',
    colorOtherCountryParaguay: 'var(--color-other-country-paraguay)',
    colorOtherCountryPeru: 'var(--color-other-country-peru)',
    colorOtherCountryPhilippines: 'var(--color-other-country-philippines)',
    colorOtherCountryPoland: 'var(--color-other-country-poland)',
    colorOtherCountryQatar: 'var(--color-other-country-qatar)',
    colorOtherCountryPortugal: 'var(--color-other-country-portugal)',
    colorOtherCountryRomania: 'var(--color-other-country-romania)',
    colorOtherCountryRussia: 'var(--color-other-country-russia)',
    colorOtherCountryRwanda: 'var(--color-other-country-rwanda)',
    colorOtherCountrySaintKittsAndNevis: 'var(--color-other-country-saint-kitts-and-nevis)',
    colorOtherCountrySaintLucia: 'var(--color-other-country-saint-lucia)',
    colorOtherCountrySaintVincentAndTheGrenadines: 'var(--color-other-country-saint-vincent-and-the-grenadines)',
    colorOtherCountrySamoa: 'var(--color-other-country-samoa)',
    colorOtherCountrySaoTomeAndPrincipe: 'var(--color-other-country-sao-tome-and-principe)',
    colorOtherCountrySaudiArabia: 'var(--color-other-country-saudi-arabia)',
    colorOtherCountrySenegal: 'var(--color-other-country-senegal)',
    colorOtherCountrySerbia: 'var(--color-other-country-serbia)',
    colorOtherCountrySeychelles: 'var(--color-other-country-seychelles)',
    colorOtherCountrySierraLeone: 'var(--color-other-country-sierra-leone)',
    colorOtherCountrySingapore: 'var(--color-other-country-singapore)',
    colorOtherCountrySlovakia: 'var(--color-other-country-slovakia)',
    colorOtherCountrySlovenia: 'var(--color-other-country-slovenia)',
    colorOtherCountrySolomonIslands: 'var(--color-other-country-solomon-islands)',
    colorOtherCountrySomalia: 'var(--color-other-country-somalia)',
    colorOtherCountrySouthAfrica: 'var(--color-other-country-south-africa)',
    colorOtherCountrySouthKorea: 'var(--color-other-country-south-korea)',
    colorOtherCountrySouthSudan: 'var(--color-other-country-south-sudan)',
    colorOtherCountrySpain: 'var(--color-other-country-spain)',
    colorOtherCountrySriLanka: 'var(--color-other-country-sri-lanka)',
    colorOtherCountrySudan: 'var(--color-other-country-sudan)',
    colorOtherCountrySuriname: 'var(--color-other-country-suriname)',
    colorOtherCountrySweden: 'var(--color-other-country-sweden)',
    colorOtherCountrySwitzerland: 'var(--color-other-country-switzerland)',
    colorOtherCountrySyria: 'var(--color-other-country-syria)',
    colorOtherCountryTajikistan: 'var(--color-other-country-tajikistan)',
    colorOtherCountryTanzania: 'var(--color-other-country-tanzania)',
    colorOtherCountryThailand: 'var(--color-other-country-thailand)',
    colorOtherCountryTogo: 'var(--color-other-country-togo)',
    colorOtherCountryTonga: 'var(--color-other-country-tonga)',
    colorOtherCountryTrinidadAndTobago: 'var(--color-other-country-trinidad-and-tobago)',
    colorOtherCountryTunisia: 'var(--color-other-country-tunisia)',
    colorOtherCountryTurkey: 'var(--color-other-country-turkey)',
    colorOtherCountryTurkmenistan: 'var(--color-other-country-turkmenistan)',
    colorOtherCountryTuvalu: 'var(--color-other-country-tuvalu)',
    colorOtherCountryUganda: 'var(--color-other-country-uganda)',
    colorOtherCountryUkraine: 'var(--color-other-country-ukraine)',
    colorOtherCountryUnitedArabEmirates: 'var(--color-other-country-united-arab-emirates)',
    colorOtherCountryUnitedKingdom: 'var(--color-other-country-united-kingdom)',
    colorOtherCountryUnitedStates: 'var(--color-other-country-united-states)',
    colorOtherCountryUruguay: 'var(--color-other-country-uruguay)',
    colorOtherCountryUzbekistan: 'var(--color-other-country-uzbekistan)',
    colorOtherCountryVanuatu: 'var(--color-other-country-vanuatu)',
    colorOtherCountryVatican: 'var(--color-other-country-vatican)',
    colorOtherCountryVenezuela: 'var(--color-other-country-venezuela)',
    colorOtherCountryVietnam: 'var(--color-other-country-vietnam)',
    colorOtherCountryYemen: 'var(--color-other-country-yemen)',
    colorOtherCountryZambia: 'var(--color-other-country-zambia)',
    colorOtherCountryZimbabwe: 'var(--color-other-country-zimbabwe)',
    colorOtherCountryHongKong: 'var(--color-other-country-hong-kong)',
    colorOtherCurrencyUsDollar: 'var(--color-other-currency-us-dollar)',
    colorOtherCurrencyEuro: 'var(--color-other-currency-euro)',
    colorOtherCurrencyJapaneseYen: 'var(--color-other-currency-japanese-yen)',
    colorOtherCurrencyGreatBritainPound: 'var(--color-other-currency-great-britain-pound)',
    colorOtherCurrencyAustralianDollar: 'var(--color-other-currency-australian-dollar)',
    colorOtherCurrencyCanadianDollar: 'var(--color-other-currency-canadian-dollar)',
    colorOtherCurrencySwissFranc: 'var(--color-other-currency-swiss-franc)',
    colorOtherCurrencyChineseYuan: 'var(--color-other-currency-chinese-yuan)',
    colorOtherCurrencyHongKongDollar: 'var(--color-other-currency-hong-kong-dollar)',
    colorOtherCurrencyNewZealandDollar: 'var(--color-other-currency-new-zealand-dollar)',
    colorOtherCurrencyAfghanAfghani: 'var(--color-other-currency-afghan-afghani)',
    colorOtherCurrencyAlbanianLek: 'var(--color-other-currency-albanian-lek)',
    colorOtherCurrencyAlgerianDinar: 'var(--color-other-currency-algerian-dinar)',
    colorOtherCurrencyAngolanKwanza: 'var(--color-other-currency-angolan-kwanza)',
    colorOtherCurrencyArgentinePeso: 'var(--color-other-currency-argentine-peso)',
    colorOtherCurrencyArmenianDram: 'var(--color-other-currency-armenian-dram)',
    colorOtherCurrencyArubanFlorin: 'var(--color-other-currency-aruban-florin)',
    colorOtherCurrencyAzerbaijanManat: 'var(--color-other-currency-azerbaijan-manat)',
    colorOtherCurrencyBahamianDollar: 'var(--color-other-currency-bahamian-dollar)',
    colorOtherCurrencyBahrainiDinar: 'var(--color-other-currency-bahraini-dinar)',
    colorOtherCurrencyBangladeshiTaka: 'var(--color-other-currency-bangladeshi-taka)',
    colorOtherCurrencyBarbadianDollar: 'var(--color-other-currency-barbadian-dollar)',
    colorOtherCurrencyBermudianDollar: 'var(--color-other-currency-bermudian-dollar)',
    colorOtherCurrencyBelarusianRuble: 'var(--color-other-currency-belarusian-ruble)',
    colorOtherCurrencyBelizeDollar: 'var(--color-other-currency-belize-dollar)',
    colorOtherCurrencyBhutaneseNgultrum: 'var(--color-other-currency-bhutanese-ngultrum)',
    colorOtherCurrencyBolivianBoliviano: 'var(--color-other-currency-bolivian-boliviano)',
    colorOtherCurrencyConvertibleMark: 'var(--color-other-currency-convertible-mark)',
    colorOtherCurrencyBotswanaPula: 'var(--color-other-currency-botswana-pula)',
    colorOtherCurrencyBruneiDollar: 'var(--color-other-currency-brunei-dollar)',
    colorOtherCurrencyBulgarianLev: 'var(--color-other-currency-bulgarian-lev)',
    colorOtherCurrencyBrazilianReal: 'var(--color-other-currency-brazilian-real)',
    colorOtherCurrencyBurundiFranc: 'var(--color-other-currency-burundi-franc)',
    colorOtherCurrencyCaboVerdeanEscudo: 'var(--color-other-currency-cabo-verdean-escudo)',
    colorOtherCurrencyCambodianRiel: 'var(--color-other-currency-cambodian-riel)',
    colorOtherCurrencyCaymanIslandsDollar: 'var(--color-other-currency-cayman-islands-dollar)',
    colorOtherCurrencyCentralAfricanFranc: 'var(--color-other-currency-central-african-franc)',
    colorOtherCurrencyChileanPeso: 'var(--color-other-currency-chilean-peso)',
    colorOtherCurrencyFranc: 'var(--color-other-currency-franc)',
    colorOtherCurrencyColombianPeso: 'var(--color-other-currency-colombian-peso)',
    colorOtherCurrencyComorianFranc: 'var(--color-other-currency-comorian-franc)',
    colorOtherCurrencyCongoleseFranc: 'var(--color-other-currency-congolese-franc)',
    colorOtherCurrencyCookIslandsDollar: 'var(--color-other-currency-cook-islands-dollar)',
    colorOtherCurrencyCostaRicanColon: 'var(--color-other-currency-costa-rican-colon)',
    colorOtherCurrencyCroatianKuna: 'var(--color-other-currency-croatian-kuna)',
    colorOtherCurrencyCubanPeso: 'var(--color-other-currency-cuban-peso)',
    colorOtherCurrencyCzechKoruna: 'var(--color-other-currency-czech-koruna)',
    colorOtherCurrencyDanishKrone: 'var(--color-other-currency-danish-krone)',
    colorOtherCurrencyDjiboutianFranc: 'var(--color-other-currency-djiboutian-franc)',
    colorOtherCurrencyDominicanPeso: 'var(--color-other-currency-dominican-peso)',
    colorOtherCurrencyEastCaribbeanDollar: 'var(--color-other-currency-east-caribbean-dollar)',
    colorOtherCurrencyEgyptianPound: 'var(--color-other-currency-egyptian-pound)',
    colorOtherCurrencyEritreanNakfa: 'var(--color-other-currency-eritrean-nakfa)',
    colorOtherCurrencyEthiopianBirr: 'var(--color-other-currency-ethiopian-birr)',
    colorOtherCurrencyFalklandIslandsPound: 'var(--color-other-currency-falkland-islands-pound)',
    colorOtherCurrencyFaroeseKrona: 'var(--color-other-currency-faroese-krona)',
    colorOtherCurrencyFijianDollar: 'var(--color-other-currency-fijian-dollar)',
    colorOtherCurrencyGambianDalasi: 'var(--color-other-currency-gambian-dalasi)',
    colorOtherCurrencyGeorgianLari: 'var(--color-other-currency-georgian-lari)',
    colorOtherCurrencyGhanaianCedi: 'var(--color-other-currency-ghanaian-cedi)',
    colorOtherCurrencyGibraltarPound: 'var(--color-other-currency-gibraltar-pound)',
    colorOtherCurrencyGuatemalanQuetzal: 'var(--color-other-currency-guatemalan-quetzal)',
    colorOtherCurrencyGuernseyPound: 'var(--color-other-currency-guernsey-pound)',
    colorOtherCurrencyGuineanFranc: 'var(--color-other-currency-guinean-franc)',
    colorOtherCurrencyGuyaneseDollar: 'var(--color-other-currency-guyanese-dollar)',
    colorOtherCurrencyHaitianGourde: 'var(--color-other-currency-haitian-gourde)',
    colorOtherCurrencyHonduranLempira: 'var(--color-other-currency-honduran-lempira)',
    colorOtherCurrencyHungarianForint: 'var(--color-other-currency-hungarian-forint)',
    colorOtherCurrencyIcelandicKrona: 'var(--color-other-currency-icelandic-krona)',
    colorOtherCurrencyIndianRupee: 'var(--color-other-currency-indian-rupee)',
    colorOtherCurrencyIndonesianRupiah: 'var(--color-other-currency-indonesian-rupiah)',
    colorOtherCurrencyIranianRial: 'var(--color-other-currency-iranian-rial)',
    colorOtherCurrencyIraqiDinar: 'var(--color-other-currency-iraqi-dinar)',
    colorOtherCurrencyIsraeliNewShekel: 'var(--color-other-currency-israeli-new-shekel)',
    colorOtherCurrencyJamaicanDollar: 'var(--color-other-currency-jamaican-dollar)',
    colorOtherCurrencyJerseyPound: 'var(--color-other-currency-jersey-pound)',
    colorOtherCurrencyJordanianDinar: 'var(--color-other-currency-jordanian-dinar)',
    colorOtherCurrencyKazakhstaniTenge: 'var(--color-other-currency-kazakhstani-tenge)',
    colorOtherCurrencyKenyanShilling: 'var(--color-other-currency-kenyan-shilling)',
    colorOtherCurrencyKuwaitiDinar: 'var(--color-other-currency-kuwaiti-dinar)',
    colorOtherCurrencyKyrgyzstaniSom: 'var(--color-other-currency-kyrgyzstani-som)',
    colorOtherCurrencyLaoKip: 'var(--color-other-currency-lao-kip)',
    colorOtherCurrencyLebanesePound: 'var(--color-other-currency-lebanese-pound)',
    colorOtherCurrencyLesothoLoti: 'var(--color-other-currency-lesotho-loti)',
    colorOtherCurrencyLiberianDollar: 'var(--color-other-currency-liberian-dollar)',
    colorOtherCurrencyLibyanDinar: 'var(--color-other-currency-libyan-dinar)',
    colorOtherCurrencyMacanesePataca: 'var(--color-other-currency-macanese-pataca)',
    colorOtherCurrencyMacedonianDenar: 'var(--color-other-currency-macedonian-denar)',
    colorOtherCurrencyMalagasyAriary: 'var(--color-other-currency-malagasy-ariary)',
    colorOtherCurrencyMalaysianRinggit: 'var(--color-other-currency-malaysian-ringgit)',
    colorOtherCurrencyMalawianKwacha: 'var(--color-other-currency-malawian-kwacha)',
    colorOtherCurrencyMaldivianRufiyaa: 'var(--color-other-currency-maldivian-rufiyaa)',
    colorOtherCurrencyManxPound: 'var(--color-other-currency-manx-pound)',
    colorOtherCurrencyMauritanianOuguiya: 'var(--color-other-currency-mauritanian-ouguiya)',
    colorOtherCurrencyMauritianRupee: 'var(--color-other-currency-mauritian-rupee)',
    colorOtherCurrencyMexicanPeso: 'var(--color-other-currency-mexican-peso)',
    colorOtherCurrencyMoldovanLeu: 'var(--color-other-currency-moldovan-leu)',
    colorOtherCurrencyMongolianTugrik: 'var(--color-other-currency-mongolian-tugrik)',
    colorOtherCurrencyMoroccanDirham: 'var(--color-other-currency-moroccan-dirham)',
    colorOtherCurrencyMozambicanMetical: 'var(--color-other-currency-mozambican-metical)',
    colorOtherCurrencyMyanmarKyat: 'var(--color-other-currency-myanmar-kyat)',
    colorOtherCurrencyNamibianDollar: 'var(--color-other-currency-namibian-dollar)',
    colorOtherCurrencyNepaleseRupee: 'var(--color-other-currency-nepalese-rupee)',
    colorOtherCurrencyGuilder: 'var(--color-other-currency-guilder)',
    colorOtherCurrencyNewTaiwanDollar: 'var(--color-other-currency-new-taiwan-dollar)',
    colorOtherCurrencyNicaraguanCordoba: 'var(--color-other-currency-nicaraguan-cordoba)',
    colorOtherCurrencyNigerianNaira: 'var(--color-other-currency-nigerian-naira)',
    colorOtherCurrencyNorthKoreanWon: 'var(--color-other-currency-north-korean-won)',
    colorOtherCurrencyNorwegianKrone: 'var(--color-other-currency-norwegian-krone)',
    colorOtherCurrencyOmaniRial: 'var(--color-other-currency-omani-rial)',
    colorOtherCurrencyPakistaniRupee: 'var(--color-other-currency-pakistani-rupee)',
    colorOtherCurrencyPapuaNewGuineanKina: 'var(--color-other-currency-papua-new-guinean-kina)',
    colorOtherCurrencyParaguayanGuarani: 'var(--color-other-currency-paraguayan-guarani)',
    colorOtherCurrencyPeruvianSol: 'var(--color-other-currency-peruvian-sol)',
    colorOtherCurrencyPhilippinePeso: 'var(--color-other-currency-philippine-peso)',
    colorOtherCurrencyPolishZloty: 'var(--color-other-currency-polish-zloty)',
    colorOtherCurrencyQatariRiyal: 'var(--color-other-currency-qatari-riyal)',
    colorOtherCurrencyRomanianLeu: 'var(--color-other-currency-romanian-leu)',
    colorOtherCurrencyRussianRuble: 'var(--color-other-currency-russian-ruble)',
    colorOtherCurrencyRwandanFranc: 'var(--color-other-currency-rwandan-franc)',
    colorOtherCurrencySaintHelenaPound: 'var(--color-other-currency-saint-helena-pound)',
    colorOtherCurrencySamoanTala: 'var(--color-other-currency-samoan-tala)',
    colorOtherCurrencyDobra: 'var(--color-other-currency-dobra)',
    colorOtherCurrencySaudiArabianRiyal: 'var(--color-other-currency-saudi-arabian-riyal)',
    colorOtherCurrencySerbianDinar: 'var(--color-other-currency-serbian-dinar)',
    colorOtherCurrencySeychelloisRupee: 'var(--color-other-currency-seychellois-rupee)',
    colorOtherCurrencySierraLeoneanLeone: 'var(--color-other-currency-sierra-leonean-leone)',
    colorOtherCurrencySingaporeDollar: 'var(--color-other-currency-singapore-dollar)',
    colorOtherCurrencySolomonIslandsDollar: 'var(--color-other-currency-solomon-islands-dollar)',
    colorOtherCurrencySomaliShilling: 'var(--color-other-currency-somali-shilling)',
    colorOtherCurrencySouthAfricanRand: 'var(--color-other-currency-south-african-rand)',
    colorOtherCurrencySouthKoreanWon: 'var(--color-other-currency-south-korean-won)',
    colorOtherCurrencySouthSudanesePound: 'var(--color-other-currency-south-sudanese-pound)',
    colorOtherCurrencySriLankanRupee: 'var(--color-other-currency-sri-lankan-rupee)',
    colorOtherCurrencySudanesePound: 'var(--color-other-currency-sudanese-pound)',
    colorOtherCurrencySurinameseDollar: 'var(--color-other-currency-surinamese-dollar)',
    colorOtherCurrencySwaziLilangeni: 'var(--color-other-currency-swazi-lilangeni)',
    colorOtherCurrencySyrianPound: 'var(--color-other-currency-syrian-pound)',
    colorOtherCurrencySwedishKrona: 'var(--color-other-currency-swedish-krona)',
    colorOtherCurrencyTajikistaniSomoni: 'var(--color-other-currency-tajikistani-somoni)',
    colorOtherCurrencyTanzanianShilling: 'var(--color-other-currency-tanzanian-shilling)',
    colorOtherCurrencyThaiBaht: 'var(--color-other-currency-thai-baht)',
    colorOtherCurrencyTonganPaanga: 'var(--color-other-currency-tongan-paanga)',
    colorOtherCurrencyDollar: 'var(--color-other-currency-dollar)',
    colorOtherCurrencyTunisianDinar: 'var(--color-other-currency-tunisian-dinar)',
    colorOtherCurrencyTurkishLira: 'var(--color-other-currency-turkish-lira)',
    colorOtherCurrencyTurkmenManat: 'var(--color-other-currency-turkmen-manat)',
    colorOtherCurrencyDirham: 'var(--color-other-currency-dirham)',
    colorOtherCurrencyUgandanShilling: 'var(--color-other-currency-ugandan-shilling)',
    colorOtherCurrencyUkrainianHryvnia: 'var(--color-other-currency-ukrainian-hryvnia)',
    colorOtherCurrencyUruguayanPeso: 'var(--color-other-currency-uruguayan-peso)',
    colorOtherCurrencyUzbekistaniSom: 'var(--color-other-currency-uzbekistani-som)',
    colorOtherCurrencyVanuatuVatu: 'var(--color-other-currency-vanuatu-vatu)',
    colorOtherCurrencyVenezuelanBolivar: 'var(--color-other-currency-venezuelan-bolivar)',
    colorOtherCurrencyVietnameseDong: 'var(--color-other-currency-vietnamese-dong)',
    colorOtherCurrencyWestAfricanFranc: 'var(--color-other-currency-west-african-franc)',
    colorOtherCurrencyYemeniRial: 'var(--color-other-currency-yemeni-rial)',
    colorOtherCurrencyZambianKwacha: 'var(--color-other-currency-zambian-kwacha)',
    colorOtherIndustryCommunicationMedia: 'var(--color-other-industry-communication-media)',
    colorOtherIndustryConsumerDiscretionary: 'var(--color-other-industry-consumer-discretionary)',
    colorOtherIndustryConsumerStaples: 'var(--color-other-industry-consumer-staples)',
    colorOtherIndustryEnergy: 'var(--color-other-industry-energy)',
    colorOtherIndustryFinancials: 'var(--color-other-industry-financials)',
    colorOtherIndustryGovernment: 'var(--color-other-industry-government)',
    colorOtherIndustryHealthCare: 'var(--color-other-industry-health-care)',
    colorOtherIndustryIndustrials: 'var(--color-other-industry-industrials)',
    colorOtherIndustryInformationTechnology: 'var(--color-other-industry-information-technology)',
    colorOtherIndustryMaterials: 'var(--color-other-industry-materials)',
    colorOtherIndustryRealEstate: 'var(--color-other-industry-real-estate)',
    colorOtherIndustryUtilities: 'var(--color-other-industry-utilities)',
    colorOtherIndustryInteractiveHomeEntertainment: 'var(--color-other-industry-interactive-home-entertainment)',
    colorOtherIndustryInteractiveMediaServices: 'var(--color-other-industry-interactive-media-services)',
    colorOtherIndustryBroadcasting: 'var(--color-other-industry-broadcasting)',
    colorOtherIndustryCableSatellite: 'var(--color-other-industry-cable-satellite)',
    colorOtherIndustryPublishing: 'var(--color-other-industry-publishing)',
    colorOtherIndustryMoviesEntertainment: 'var(--color-other-industry-movies-entertainment)',
    colorOtherIndustryAlternativeCarriers: 'var(--color-other-industry-alternative-carriers)',
    colorOtherIndustryIntegratedTelecommunicationServices: 'var(--color-other-industry-integrated-telecommunication-services)',
    colorOtherIndustryAdvertising: 'var(--color-other-industry-advertising)',
    colorOtherIndustryWirelessTelecommunicationServices: 'var(--color-other-industry-wireless-telecommunication-services)',
    colorOtherIndustryAutomobileManufacturers: 'var(--color-other-industry-automobile-manufacturers)',
    colorOtherIndustryMotorcycleManufacturers: 'var(--color-other-industry-motorcycle-manufacturers)',
    colorOtherIndustryAutoPartsEquipment: 'var(--color-other-industry-auto-parts-equipment)',
    colorOtherIndustryTiresRubber: 'var(--color-other-industry-tires-rubber)',
    colorOtherIndustryConsumerServices: 'var(--color-other-industry-consumer-services)',
    colorOtherIndustryDistributors: 'var(--color-other-industry-distributors)',
    colorOtherIndustryEducationalServices: 'var(--color-other-industry-educational-services)',
    colorOtherIndustryHomeFurnishings: 'var(--color-other-industry-home-furnishings)',
    colorOtherIndustryHouseholdAppliances: 'var(--color-other-industry-household-appliances)',
    colorOtherIndustryHousewaresSpecialties: 'var(--color-other-industry-housewares-specialties)',
    colorOtherIndustryCasinosGaming: 'var(--color-other-industry-casinos-gaming)',
    colorOtherIndustryHotelsResortsCruiseLines: 'var(--color-other-industry-hotels-resorts-cruise-lines)',
    colorOtherIndustryLeisureFacilities: 'var(--color-other-industry-leisure-facilities)',
    colorOtherIndustryRestaurants: 'var(--color-other-industry-restaurants)',
    colorOtherIndustryInternetDirectMarketingRetail: 'var(--color-other-industry-internet-direct-marketing-retail)',
    colorOtherIndustryDepartmentStores: 'var(--color-other-industry-department-stores)',
    colorOtherIndustryGeneralMerchandiseStores: 'var(--color-other-industry-general-merchandise-stores)',
    colorOtherIndustryApparelRetail: 'var(--color-other-industry-apparel-retail)',
    colorOtherIndustryComputerElectronicsRetail: 'var(--color-other-industry-computer-electronics-retail)',
    colorOtherIndustryHomeImprovementRetail: 'var(--color-other-industry-home-improvement-retail)',
    colorOtherIndustrySpecialtyStores: 'var(--color-other-industry-specialty-stores)',
    colorOtherIndustryAutomotiveRetail: 'var(--color-other-industry-automotive-retail)',
    colorOtherIndustryHomefurnishingRetail: 'var(--color-other-industry-homefurnishing-retail)',
    colorOtherIndustryLeisureProducts: 'var(--color-other-industry-leisure-products)',
    colorOtherIndustryApparelAccessoriesLuxuryGoods: 'var(--color-other-industry-apparel-accessories-luxury-goods)',
    colorOtherIndustryFootwear: 'var(--color-other-industry-footwear)',
    colorOtherIndustryTextiles: 'var(--color-other-industry-textiles)',
    colorOtherIndustryConsumerElectronics: 'var(--color-other-industry-consumer-electronics)',
    colorOtherIndustryHomebuilding: 'var(--color-other-industry-homebuilding)',
    colorOtherIndustryBrewers: 'var(--color-other-industry-brewers)',
    colorOtherIndustryDistillersVintners: 'var(--color-other-industry-distillers-vintners)',
    colorOtherIndustrySoftDrinks: 'var(--color-other-industry-soft-drinks)',
    colorOtherIndustryDrugRetail: 'var(--color-other-industry-drug-retail)',
    colorOtherIndustryFoodDistributors: 'var(--color-other-industry-food-distributors)',
    colorOtherIndustryFoodRetail: 'var(--color-other-industry-food-retail)',
    colorOtherIndustryHypermarketsSuperCenters: 'var(--color-other-industry-hypermarkets-super-centers)',
    colorOtherIndustryAgriculturalProducts: 'var(--color-other-industry-agricultural-products)',
    colorOtherIndustryPackagedFoodsMeats: 'var(--color-other-industry-packaged-foods-meats)',
    colorOtherIndustryHouseholdProducts: 'var(--color-other-industry-household-products)',
    colorOtherIndustryPersonalProducts: 'var(--color-other-industry-personal-products)',
    colorOtherIndustryTobacco: 'var(--color-other-industry-tobacco)',
    colorOtherIndustryEnergyEquipmentServices: 'var(--color-other-industry-energy-equipment-services)',
    colorOtherIndustryOilGasEquipmentServices: 'var(--color-other-industry-oil-gas-equipment-services)',
    colorOtherIndustryOilGasDrilling: 'var(--color-other-industry-oil-gas-drilling)',
    colorOtherIndustryIntegratedOilGas: 'var(--color-other-industry-integrated-oil-gas)',
    colorOtherIndustryOilGasExplorationProduction: 'var(--color-other-industry-oil-gas-exploration-production)',
    colorOtherIndustryOilGasRefiningMarketing: 'var(--color-other-industry-oil-gas-refining-marketing)',
    colorOtherIndustryOilGasStorageTransportation: 'var(--color-other-industry-oil-gas-storage-transportation)',
    colorOtherIndustryCoalConsumableFuels: 'var(--color-other-industry-coal-consumable-fuels)',
    colorOtherIndustryAssetManagement: 'var(--color-other-industry-asset-management)',
    colorOtherIndustryDiversifiedBanks: 'var(--color-other-industry-diversified-banks)',
    colorOtherIndustryRegionalBanks: 'var(--color-other-industry-regional-banks)',
    colorOtherIndustryConsumerFinance: 'var(--color-other-industry-consumer-finance)',
    colorOtherIndustryDiversifiedFinancialServices: 'var(--color-other-industry-diversified-financial-services)',
    colorOtherIndustryDiversifiedReits: 'var(--color-other-industry-diversified-reits)',
    colorOtherIndustryIndustrialReits: 'var(--color-other-industry-industrial-reits)',
    colorOtherIndustryHotelResortReits: 'var(--color-other-industry-hotel-resort-reits)',
    colorOtherIndustryOfficeReits: 'var(--color-other-industry-office-reits)',
    colorOtherIndustryHealthCareReits: 'var(--color-other-industry-health-care-reits)',
    colorOtherIndustryResidentialReits: 'var(--color-other-industry-residential-reits)',
    colorOtherIndustryRetailReits: 'var(--color-other-industry-retail-reits)',
    colorOtherIndustrySpecializedReits: 'var(--color-other-industry-specialized-reits)',
    colorOtherIndustryInsuranceBrokers: 'var(--color-other-industry-insurance-brokers)',
    colorOtherIndustryLifeHealthInsurance: 'var(--color-other-industry-life-health-insurance)',
    colorOtherIndustryMultiLineInsurance: 'var(--color-other-industry-multi-line-insurance)',
    colorOtherIndustryPropertyCasualtyInsurance: 'var(--color-other-industry-property-casualty-insurance)',
    colorOtherIndustryReinsurance: 'var(--color-other-industry-reinsurance)',
    colorOtherIndustryMortgageRealEstateInvestmentTrustsReits: 'var(--color-other-industry-mortgage-real-estate-investment-trusts-reits)',
    colorOtherIndustrySpecialtyFinance: 'var(--color-other-industry-specialty-finance)',
    colorOtherIndustryThriftsMortgageFinance: 'var(--color-other-industry-thrifts-mortgage-finance)',
    colorOtherIndustryMultiSectorHoldings: 'var(--color-other-industry-multi-sector-holdings)',
    colorOtherIndustryInvestmentBankingBrokerage: 'var(--color-other-industry-investment-banking-brokerage)',
    colorOtherIndustryDiversifiedCapitalMarkets: 'var(--color-other-industry-diversified-capital-markets)',
    colorOtherIndustryFinancialExchangesData: 'var(--color-other-industry-financial-exchanges-data)',
    colorOtherIndustryAgencies: 'var(--color-other-industry-agencies)',
    colorOtherIndustryMunicipalHealthcare: 'var(--color-other-industry-municipal-healthcare)',
    colorOtherIndustryMunicipalHigherEducation: 'var(--color-other-industry-municipal-higher-education)',
    colorOtherIndustryMunicipalStatelocalGovt: 'var(--color-other-industry-municipal-statelocal-govt)',
    colorOtherIndustrySovereign: 'var(--color-other-industry-sovereign)',
    colorOtherIndustrySupranationalBank: 'var(--color-other-industry-supranational-bank)',
    colorOtherIndustryGovernmentDevelopmentBanks: 'var(--color-other-industry-government-development-banks)',
    colorOtherIndustryRegionalAgencies: 'var(--color-other-industry-regional-agencies)',
    colorOtherIndustryBiotechnology: 'var(--color-other-industry-biotechnology)',
    colorOtherIndustryPharmaceuticals: 'var(--color-other-industry-pharmaceuticals)',
    colorOtherIndustryHealthCareEquipment: 'var(--color-other-industry-health-care-equipment)',
    colorOtherIndustryHealthCareSupplies: 'var(--color-other-industry-health-care-supplies)',
    colorOtherIndustryHealthCareDistributors: 'var(--color-other-industry-health-care-distributors)',
    colorOtherIndustryHealthCareServices: 'var(--color-other-industry-health-care-services)',
    colorOtherIndustryHealthCareFacilities: 'var(--color-other-industry-health-care-facilities)',
    colorOtherIndustryManagedHealthCare: 'var(--color-other-industry-managed-health-care)',
    colorOtherIndustryHealthCareTechnology: 'var(--color-other-industry-health-care-technology)',
    colorOtherIndustryLifeSciencesToolsServices: 'var(--color-other-industry-life-sciences-tools-services)',
    colorOtherIndustryAerospaceDefense: 'var(--color-other-industry-aerospace-defense)',
    colorOtherIndustryAirlines: 'var(--color-other-industry-airlines)',
    colorOtherIndustryBuildingProducts: 'var(--color-other-industry-building-products)',
    colorOtherIndustryEnvironmentalFacilitiesServices: 'var(--color-other-industry-environmental-facilities-services)',
    colorOtherIndustryOfficeServicesSupplies: 'var(--color-other-industry-office-services-supplies)',
    colorOtherIndustryDiversifiedSupportServices: 'var(--color-other-industry-diversified-support-services)',
    colorOtherIndustrySecurityAlarmServices: 'var(--color-other-industry-security-alarm-services)',
    colorOtherIndustryConglomerates: 'var(--color-other-industry-conglomerates)',
    colorOtherIndustryConstructionEngineering: 'var(--color-other-industry-construction-engineering)',
    colorOtherIndustryElectricalComponentsEquipment: 'var(--color-other-industry-electrical-components-equipment)',
    colorOtherIndustryHeavyElectricalEquipment: 'var(--color-other-industry-heavy-electrical-equipment)',
    colorOtherIndustryConstructionMachineryHeavyTrucks: 'var(--color-other-industry-construction-machinery-heavy-trucks)',
    colorOtherIndustryAgriculturalFarmMachinery: 'var(--color-other-industry-agricultural-farm-machinery)',
    colorOtherIndustryIndustrialMachinery: 'var(--color-other-industry-industrial-machinery)',
    colorOtherIndustryMarine: 'var(--color-other-industry-marine)',
    colorOtherIndustryHumanResourceEmploymentServices: 'var(--color-other-industry-human-resource-employment-services)',
    colorOtherIndustryResearchConsultingServices: 'var(--color-other-industry-research-consulting-services)',
    colorOtherIndustryRailroads: 'var(--color-other-industry-railroads)',
    colorOtherIndustryTrucking: 'var(--color-other-industry-trucking)',
    colorOtherIndustryHighwaysRailtracks: 'var(--color-other-industry-highways-railtracks)',
    colorOtherIndustryTradingCompaniesDistributors: 'var(--color-other-industry-trading-companies-distributors)',
    colorOtherIndustryTransportationFreightLogistics: 'var(--color-other-industry-transportation-freight-logistics)',
    colorOtherIndustryAirportServices: 'var(--color-other-industry-airport-services)',
    colorOtherIndustryMarinePortsServices: 'var(--color-other-industry-marine-ports-services)',
    colorOtherIndustryCommercialPrinting: 'var(--color-other-industry-commercial-printing)',
    colorOtherIndustryCommunicationsEquipment: 'var(--color-other-industry-communications-equipment)',
    colorOtherIndustryElectronicEquipmentInstrumentsComponents: 'var(--color-other-industry-electronic-equipment-instruments-components)',
    colorOtherIndustryInformationTechnologyServices: 'var(--color-other-industry-information-technology-services)',
    colorOtherIndustrySemiconductorEquipment: 'var(--color-other-industry-semiconductor-equipment)',
    colorOtherIndustrySemiconductors: 'var(--color-other-industry-semiconductors)',
    colorOtherIndustryApplicationSoftware: 'var(--color-other-industry-application-software)',
    colorOtherIndustrySystemsSoftware: 'var(--color-other-industry-systems-software)',
    colorOtherIndustryTechnologyHardwareStoragePeripherals: 'var(--color-other-industry-technology-hardware-storage-peripherals)',
    colorOtherIndustryDataProcessingOutsourcedServices: 'var(--color-other-industry-data-processing-outsourced-services)',
    colorOtherIndustryInternetServicesInfrastructure: 'var(--color-other-industry-internet-services-infrastructure)',
    colorOtherIndustryElectronicEquipmentInstruments: 'var(--color-other-industry-electronic-equipment-instruments)',
    colorOtherIndustryElectronicManufacturingServices: 'var(--color-other-industry-electronic-manufacturing-services)',
    colorOtherIndustryTechnologyDistributors: 'var(--color-other-industry-technology-distributors)',
    colorOtherIndustryCommodityChemicals: 'var(--color-other-industry-commodity-chemicals)',
    colorOtherIndustryDiversifiedChemicals: 'var(--color-other-industry-diversified-chemicals)',
    colorOtherIndustryFertilizersAgriculturalChemicals: 'var(--color-other-industry-fertilizers-agricultural-chemicals)',
    colorOtherIndustryIndustrialGases: 'var(--color-other-industry-industrial-gases)',
    colorOtherIndustrySpecialtyChemicals: 'var(--color-other-industry-specialty-chemicals)',
    colorOtherIndustryImportBank: 'var(--color-other-industry-import-bank)',
    colorOtherSectorStudentLoan: 'var(--color-other-sector-student-loan)',
    colorOtherSectorConsumerLoans: 'var(--color-other-sector-consumer-loans)',
    colorOtherSectorPremiumFinanceOther: 'var(--color-other-sector-premium-finance-other)',
    colorOtherSectorStructuredSettlements: 'var(--color-other-sector-structured-settlements)',
    colorOtherSectorTradeReceivables: 'var(--color-other-sector-trade-receivables)',
    colorOtherSectorServicerAdvance: 'var(--color-other-sector-servicer-advance)',
    colorOtherSectorSingleFamilyRental: 'var(--color-other-sector-single-family-rental)',
    colorOtherSectorUkRmbs: 'var(--color-other-sector-uk-rmbs)',
    colorOtherSectorFfelp: 'var(--color-other-sector-ffelp)',
    colorOtherSectorPrivate: 'var(--color-other-sector-private)',
    colorOtherSectorHomeEquityInvestments: 'var(--color-other-sector-home-equity-investments)',
    colorOtherSectorAutoAuto: 'var(--color-other-sector-auto-auto)',
    colorOtherSectorAutoFloorplan: 'var(--color-other-sector-auto-floorplan)',
    colorOtherSectorAutoLease: 'var(--color-other-sector-auto-lease)',
    colorOtherSectorAutoMotorcycle: 'var(--color-other-sector-auto-motorcycle)',
    colorOtherSectorAutoPrimeLoan: 'var(--color-other-sector-auto-prime-loan)',
    colorOtherSectorAutoSubprimeLoan: 'var(--color-other-sector-auto-subprime-loan)',
    colorOtherSectorAutoUkPrime: 'var(--color-other-sector-auto-uk-prime)',
    colorOtherSectorCmbsCmbs: 'var(--color-other-sector-cmbs-cmbs)',
    colorOtherSectorCmbsAgency: 'var(--color-other-sector-cmbs-agency)',
    colorOtherSectorCmbsConduit: 'var(--color-other-sector-cmbs-conduit)',
    colorOtherSectorCmbsCreClo: 'var(--color-other-sector-cmbs-cre-clo)',
    colorOtherSectorCmbsLargeLoanSasb: 'var(--color-other-sector-cmbs-large-loan-sasb)',
    colorOtherSectorCmbsOther: 'var(--color-other-sector-cmbs-other)',
    colorOtherSectorCollateralizedLoansClosCollateralizedLoansClos: 'var(--color-other-sector-collateralized-loans-clos-collateralized-loans-clos)',
    colorOtherSectorCollateralizedLoansClosMiddleMarket: 'var(--color-other-sector-collateralized-loans-clos-middle-market)',
    colorOtherSectorCollateralizedLoansClosBroadlySyndicated: 'var(--color-other-sector-collateralized-loans-clos-broadly-syndicated)',
    colorOtherSectorCollateralizedLoansClosOther: 'var(--color-other-sector-collateralized-loans-clos-other)',
    colorOtherSectorCreditCardCreditCard: 'var(--color-other-sector-credit-card-credit-card)',
    colorOtherSectorCreditCardBankChargeCard: 'var(--color-other-sector-credit-card-bank-charge-card)',
    colorOtherSectorCreditCardRetailPrivateLabel: 'var(--color-other-sector-credit-card-retail-private-label)',
    colorOtherSectorEquipmentEquipment: 'var(--color-other-sector-equipment-equipment)',
    colorOtherSectorEquipmentAgriConstruction: 'var(--color-other-sector-equipment-agri-construction)',
    colorOtherSectorEquipmentFloorplan: 'var(--color-other-sector-equipment-floorplan)',
    colorOtherSectorEquipmentLargeTicket: 'var(--color-other-sector-equipment-large-ticket)',
    colorOtherSectorEquipmentSmallMidTicket: 'var(--color-other-sector-equipment-small-mid-ticket)',
    colorOtherSectorEsotericEsoteric: 'var(--color-other-sector-esoteric-esoteric)',
    colorOtherSectorEsotericAircraftReceivables: 'var(--color-other-sector-esoteric-aircraft-receivables)',
    colorOtherSectorEsotericCellTower: 'var(--color-other-sector-esoteric-cell-tower)',
    colorOtherSectorEsotericConsumerMarketplaceLoans: 'var(--color-other-sector-esoteric-consumer-marketplace-loans)',
    colorOtherSectorEsotericContainer: 'var(--color-other-sector-esoteric-container)',
    colorOtherSectorEsotericDevicePaymentPlans: 'var(--color-other-sector-esoteric-device-payment-plans)',
    colorOtherSectorEsotericFleetLease: 'var(--color-other-sector-esoteric-fleet-lease)',
    colorOtherSectorEsotericIpRoyalties: 'var(--color-other-sector-esoteric-ip-royalties)',
    colorOtherSectorEsotericMunicipalPaceBonds: 'var(--color-other-sector-esoteric-municipal-pace-bonds)',
    colorOtherSectorEsotericRailcar: 'var(--color-other-sector-esoteric-railcar)',
    colorOtherSectorEsotericRateReductionBonds: 'var(--color-other-sector-esoteric-rate-reduction-bonds)',
    colorOtherSectorEsotericRentalCar: 'var(--color-other-sector-esoteric-rental-car)',
    colorOtherSectorEsotericSmallBusinessLoans: 'var(--color-other-sector-esoteric-small-business-loans)',
    colorOtherSectorEsotericSolar: 'var(--color-other-sector-esoteric-solar)',
    colorOtherSectorEsotericSpecialtyFinanceOther: 'var(--color-other-sector-esoteric-specialty-finance-other)',
    colorOtherSectorEsotericTaxLiens: 'var(--color-other-sector-esoteric-tax-liens)',
    colorOtherSectorEsotericTimeshare: 'var(--color-other-sector-esoteric-timeshare)',
    colorOtherSectorEsotericTripleNetLease: 'var(--color-other-sector-esoteric-triple-net-lease)',
    colorOtherSectorEsotericWholeBusiness: 'var(--color-other-sector-esoteric-whole-business)',
    colorOtherSectorEsotericDatacenter: 'var(--color-other-sector-esoteric-datacenter)',
    colorOtherSectorEsotericBillboard: 'var(--color-other-sector-esoteric-billboard)',
    colorOtherSectorEsotericFiber: 'var(--color-other-sector-esoteric-fiber)',
    colorOtherSectorEsotericQsr: 'var(--color-other-sector-esoteric-qsr)',
    colorOtherSectorEsotericConsumerHomeImprovement: 'var(--color-other-sector-esoteric-consumer-home-improvement)',
    colorOtherSectorEsotericInsurancePremiumFinanceOther: 'var(--color-other-sector-esoteric-insurance-premium-finance-other)',
    colorOtherSectorEsotericInsuranceStructuredSettlements: 'var(--color-other-sector-esoteric-insurance-structured-settlements)',
    colorOtherSectorRmbsRmbs: 'var(--color-other-sector-rmbs-rmbs)',
    colorOtherSectorRmbsAusRmbs: 'var(--color-other-sector-rmbs-aus-rmbs)',
    colorOtherSectorRmbsCreditRiskTransfer: 'var(--color-other-sector-rmbs-credit-risk-transfer)',
    colorOtherSectorRmbsHomeEquityInvestments: 'var(--color-other-sector-rmbs-home-equity-investments)',
    colorOtherSectorRmbsNonPerformingLoans: 'var(--color-other-sector-rmbs-non-performing-loans)',
    colorOtherSectorRmbsPassThroughPrimeJumbo: 'var(--color-other-sector-rmbs-pass-through-prime-jumbo)',
    colorOtherSectorRmbsPerformingLoans: 'var(--color-other-sector-rmbs-performing-loans)',
    colorOtherSectorRmbsReSecuritization: 'var(--color-other-sector-rmbs-re-securitization)',
    colorOtherSectorRmbsNonQualifiedMortgage: 'var(--color-other-sector-rmbs-non-qualified-mortgage)',
    colorOtherSectorRmbsResidentialTransitionLoans: 'var(--color-other-sector-rmbs-residential-transition-loans)',
    colorOtherSectorRmbsSecondLiens: 'var(--color-other-sector-rmbs-second-liens)',
    colorOtherSectorRmbsReperformingLoans: 'var(--color-other-sector-rmbs-reperforming-loans)',
    colorOtherDealerBam: 'var(--color-other-dealer-bam)',
    colorOtherDealerBmo: 'var(--color-other-dealer-bmo)',
    colorOtherDealerBnp: 'var(--color-other-dealer-bnp)',
    colorOtherDealerBrc: 'var(--color-other-dealer-brc)',
    colorOtherDealerDeu: 'var(--color-other-dealer-deu)',
    colorOtherDealerGsc: 'var(--color-other-dealer-gsc)',
    colorOtherDealerJpm: 'var(--color-other-dealer-jpm)',
    colorOtherDealerMos: 'var(--color-other-dealer-mos)',
    colorOtherDealerMuf: 'var(--color-other-dealer-muf)',
    colorOtherDealerRbc: 'var(--color-other-dealer-rbc)',
    colorOtherDealerSoc: 'var(--color-other-dealer-soc)',
    colorOtherDealerWfs: 'var(--color-other-dealer-wfs)',
    colorOtherDealerLop: 'var(--color-other-dealer-lop)',
    colorOtherGradientsEm1: 'var(--color-other-gradients-em-1)',
    colorOtherGradientsEm2: 'var(--color-other-gradients-em-2)',
    colorOtherGradientsAlc1: 'var(--color-other-gradients-alc-1)',
    colorOtherGradientsAlc2: 'var(--color-other-gradients-alc-2)',
    colorOtherGradientsCommon1: 'var(--color-other-gradients-common-1)',
    colorOtherGradientsCommon2: 'var(--color-other-gradients-common-2)',
    colorOtherGradientsHyc1: 'var(--color-other-gradients-hyc-1)',
    colorOtherGradientsHyc2: 'var(--color-other-gradients-hyc-2)',
    colorOtherGradientsIgc1: 'var(--color-other-gradients-igc-1)',
    colorOtherGradientsIgc2: 'var(--color-other-gradients-igc-2)',
    colorOtherGradientsInv1: 'var(--color-other-gradients-inv-1)',
    colorOtherGradientsInv2: 'var(--color-other-gradients-inv-2)',
    colorOtherGradientsLos1: 'var(--color-other-gradients-los-1)',
    colorOtherGradientsLos2: 'var(--color-other-gradients-los-2)',
    colorOtherGradientsOrb1: 'var(--color-other-gradients-orb-1)',
    colorOtherGradientsOrb2: 'var(--color-other-gradients-orb-2)',
    colorOtherGradientsRes1: 'var(--color-other-gradients-res-1)',
    colorOtherGradientsRes2: 'var(--color-other-gradients-res-2)',
    colorOtherGradientsCfr1: 'var(--color-other-gradients-cfr-1)',
    colorOtherGradientsCfr2: 'var(--color-other-gradients-cfr-2)',
    colorOtherGradientsDrs1: 'var(--color-other-gradients-drs-1)',
    colorOtherGradientsDrs2: 'var(--color-other-gradients-drs-2)',
    colorOtherGradientsVdr1: 'var(--color-other-gradients-vdr-1)',
    colorOtherGradientsVdr2: 'var(--color-other-gradients-vdr-2)',
    colorOtherGradientsVrs1: 'var(--color-other-gradients-vrs-1)',
    colorOtherGradientsVrs2: 'var(--color-other-gradients-vrs-2)',
    colorOtherGradients17g1: 'var(--color-other-gradients-17g-1)',
    colorOtherGradients17g2: 'var(--color-other-gradients-17g-2)',
    colorOtherGradientsEvc1: 'var(--color-other-gradients-evc-1)',
    colorOtherGradientsEvc2: 'var(--color-other-gradients-evc-2)',
    colorOtherGradientsAbs1: 'var(--color-other-gradients-abs-1)',
    colorOtherGradientsAbs2: 'var(--color-other-gradients-abs-2)',
    dropshadowBlurNone: 'var(--dropshadow-blur-none)',
    dropshadowBlurXs: 'var(--dropshadow-blur-xs)',
    dropshadowBlurS: 'var(--dropshadow-blur-s)',
    dropshadowBlurM: 'var(--dropshadow-blur-m)',
    dropshadowPositioningNone: 'var(--dropshadow-positioning-none)',
    dropshadowPositioningXs: 'var(--dropshadow-positioning-xs)',
  },
  surface: {
    neutralPage: 'var(--surface-neutral-page)',
    neutralTile: 'var(--surface-neutral-tile)',
    neutralSection: 'var(--surface-neutral-section)',
    neutralBadge: 'var(--surface-neutral-badge)',
    neutralToggle: 'var(--surface-neutral-toggle)',
    neutralTag: 'var(--surface-neutral-tag)',
    neutralAction: 'var(--surface-neutral-action)',
    neutralOverlay: 'var(--surface-neutral-overlay)',
    primaryDefault: 'var(--surface-primary-default)',
    primaryDefaultHover: 'var(--surface-primary-default-hover)',
    primarySubtle: 'var(--surface-primary-subtle)',
    primarySubtleHover: 'var(--surface-primary-subtle-hover)',
    primaryOnColor: 'var(--surface-primary-on-color)',
    primaryOnColorHover: 'var(--surface-primary-on-color-hover)',
    errorDefault: 'var(--surface-error-default)',
    errorDefaultHover: 'var(--surface-error-default-hover)',
    errorSubtle: 'var(--surface-error-subtle)',
    errorSubtleHover: 'var(--surface-error-subtle-hover)',
    warningDefault: 'var(--surface-warning-default)',
    warningDefaultHover: 'var(--surface-warning-default-hover)',
    warningSubtle: 'var(--surface-warning-subtle)',
    warningSubtleHover: 'var(--surface-warning-subtle-hover)',
    successDefault: 'var(--surface-success-default)',
    successDefaultHover: 'var(--surface-success-default-hover)',
    successSubtle: 'var(--surface-success-subtle)',
    successSubtleHover: 'var(--surface-success-subtle-hover)',
    infoDefault: 'var(--surface-info-default)',
    infoDefaultHover: 'var(--surface-info-default-hover)',
    disabledDefault: 'var(--surface-disabled-default)',
    disabledSecondary: 'var(--surface-disabled-secondary)',
    disabledTertiary: 'var(--surface-disabled-tertiary)',
  },
  text: {
    neutralDefault: 'var(--text-neutral-default)',
    neutralBody: 'var(--text-neutral-body)',
    neutralCaption: 'var(--text-neutral-caption)',
    neutralPlaceholder: 'var(--text-neutral-placeholder)',
    onColorDefault: 'var(--text-on-color-default)',
    onColorBody: 'var(--text-on-color-body)',
    onColorCaption: 'var(--text-on-color-caption)',
    onColorPlaceholder: 'var(--text-on-color-placeholder)',
    primaryDefault: 'var(--text-primary-default)',
    primaryDefaultHover: 'var(--text-primary-default-hover)',
    primaryOnColor: 'var(--text-primary-on-color)',
    primaryOnColorHover: 'var(--text-primary-on-color-hover)',
    errorDefault: 'var(--text-error-default)',
    errorDefaultHover: 'var(--text-error-default-hover)',
    errorOnColor: 'var(--text-error-on-color)',
    errorOnColorHover: 'var(--text-error-on-color-hover)',
    warningDefault: 'var(--text-warning-default)',
    warningDefaultHover: 'var(--text-warning-default-hover)',
    warningOnColor: 'var(--text-warning-on-color)',
    warningOnColorHover: 'var(--text-warning-on-color-hover)',
    successDefault: 'var(--text-success-default)',
    successDefaultHover: 'var(--text-success-default-hover)',
    successOnColor: 'var(--text-success-on-color)',
    successOnColorHover: 'var(--text-success-on-color-hover)',
    infoDefault: 'var(--text-info-default)',
    infoDefaultHover: 'var(--text-info-default-hover)',
    infoOnColor: 'var(--text-info-on-color)',
    infoOnColorHover: 'var(--text-info-on-color-hover)',
    disabledDefault: 'var(--text-disabled-default)',
    disabledSecondary: 'var(--text-disabled-secondary)',
    disabledOnColor: 'var(--text-disabled-on-color)',
  },
  icon: {
    neutralDefault: 'var(--icon-neutral-default)',
    neutralDefaultHover: 'var(--icon-neutral-default-hover)',
    neutralSecondary: 'var(--icon-neutral-secondary)',
    neutralSecondaryHover: 'var(--icon-neutral-secondary-hover)',
    neutralDark: 'var(--icon-neutral-dark)',
    neutralDarkHover: 'var(--icon-neutral-dark-hover)',
    neutralOnColor: 'var(--icon-neutral-on-color)',
    primaryDefault: 'var(--icon-primary-default)',
    primaryDefaultHover: 'var(--icon-primary-default-hover)',
    primaryOnColor: 'var(--icon-primary-on-color)',
    primaryOnColorHover: 'var(--icon-primary-on-color-hover)',
    errorDefault: 'var(--icon-error-default)',
    errorDefaultHover: 'var(--icon-error-default-hover)',
    errorOnColor: 'var(--icon-error-on-color)',
    errorOnColorHover: 'var(--icon-error-on-color-hover)',
    warningDefault: 'var(--icon-warning-default)',
    warningDefaultHover: 'var(--icon-warning-default-hover)',
    warningOnColor: 'var(--icon-warning-on-color)',
    warningOnColorHover: 'var(--icon-warning-on-color-hover)',
    successDefault: 'var(--icon-success-default)',
    successDefaultHover: 'var(--icon-success-default-hover)',
    successOnColor: 'var(--icon-success-on-color)',
    successOnColorHover: 'var(--icon-success-on-color-hover)',
    infoDefault: 'var(--icon-info-default)',
    infoDefaultHover: 'var(--icon-info-default-hover)',
    infoOnColor: 'var(--icon-info-on-color)',
    infoOnColorHover: 'var(--icon-info-on-color-hover)',
    disabledDefault: 'var(--icon-disabled-default)',
    disabledOnColor: 'var(--icon-disabled-on-color)',
  },
  border: {
    neutralDefault: 'var(--border-neutral-default)',
    neutralSecondary: 'var(--border-neutral-secondary)',
    neutralTable: 'var(--border-neutral-table)',
    neutralBadge: 'var(--border-neutral-badge)',
    neutralAction: 'var(--border-neutral-action)',
    neutralOnColor: 'var(--border-neutral-on-color)',
    neutralOverlay: 'var(--border-neutral-overlay)',
    primaryDefault: 'var(--border-primary-default)',
    primaryDefaultHover: 'var(--border-primary-default-hover)',
    primarySecondary: 'var(--border-primary-secondary)',
    primarySecondaryHover: 'var(--border-primary-secondary-hover)',
    primaryFocused: 'var(--border-primary-focused)',
    primaryOnColor: 'var(--border-primary-on-color)',
    primaryOnColorHover: 'var(--border-primary-on-color-hover)',
    errorDefault: 'var(--border-error-default)',
    errorDefaultHover: 'var(--border-error-default-hover)',
    warningDefault: 'var(--border-warning-default)',
    warningDefaultHover: 'var(--border-warning-default-hover)',
    successDefault: 'var(--border-success-default)',
    successDefaultHover: 'var(--border-success-default-hover)',
    infoDefault: 'var(--border-info-default)',
    infoDefaultHover: 'var(--border-info-default-hover)',
    disabledDefault: 'var(--border-disabled-default)',
    disabledSecondary: 'var(--border-disabled-secondary)',
  },
  shadow: {
    modal: 'var(--shadow-modal)',
    tile: 'var(--shadow-tile)',
    menu: 'var(--shadow-menu)',
  },
  product: {
    alcDefault: 'var(--product-alc-default)',
    alcSecondary: 'var(--product-alc-secondary)',
    alcSubtle: 'var(--product-alc-subtle)',
    alcBorder: 'var(--product-alc-border)',
    drsDefault: 'var(--product-drs-default)',
    drsSecondary: 'var(--product-drs-secondary)',
    drsSubtle: 'var(--product-drs-subtle)',
    drsBorder: 'var(--product-drs-border)',
    evcDefault: 'var(--product-evc-default)',
    evcSecondary: 'var(--product-evc-secondary)',
    evcSubtle: 'var(--product-evc-subtle)',
    evcBorder: 'var(--product-evc-border)',
    vdrDefault: 'var(--product-vdr-default)',
    vdrSecondary: 'var(--product-vdr-secondary)',
    vdrSubtle: 'var(--product-vdr-subtle)',
    vdrBorder: 'var(--product-vdr-border)',
    losDefault: 'var(--product-los-default)',
    losSecondary: 'var(--product-los-secondary)',
    losSubtle: 'var(--product-los-subtle)',
    losBorder: 'var(--product-los-border)',
    resDefault: 'var(--product-res-default)',
    resSecondary: 'var(--product-res-secondary)',
    resSubtle: 'var(--product-res-subtle)',
    resBorder: 'var(--product-res-border)',
    vrsDefault: 'var(--product-vrs-default)',
    vrsSecondary: 'var(--product-vrs-secondary)',
    vrsSubtle: 'var(--product-vrs-subtle)',
    vrsBorder: 'var(--product-vrs-border)',
    invDefault: 'var(--product-inv-default)',
    invSecondary: 'var(--product-inv-secondary)',
    invSubtle: 'var(--product-inv-subtle)',
    invBorder: 'var(--product-inv-border)',
    '17gDefault': 'var(--product-17g-default)',
    '17gSecondary': 'var(--product-17g-secondary)',
    '17gSubtle': 'var(--product-17g-subtle)',
    '17gBorder': 'var(--product-17g-border)',
    finDefault: 'var(--product-fin-default)',
    finSecondary: 'var(--product-fin-secondary)',
    finSubtle: 'var(--product-fin-subtle)',
    finBorder: 'var(--product-fin-border)',
    orbDefault: 'var(--product-orb-default)',
    orbSecondary: 'var(--product-orb-secondary)',
    orbSubtle: 'var(--product-orb-subtle)',
    orbBorder: 'var(--product-orb-border)',
    absDefault: 'var(--product-abs-default)',
    absSecondary: 'var(--product-abs-secondary)',
    hycDefault: 'var(--product-hyc-default)',
    hycSecondary: 'var(--product-hyc-secondary)',
    igcDefault: 'var(--product-igc-default)',
    igcSecondary: 'var(--product-igc-secondary)',
    swbDefault: 'var(--product-swb-default)',
    capDefault: 'var(--product-cap-default)',
    emDefault: 'var(--product-em-default)',
    emSecondary: 'var(--product-em-secondary)',
    cfrDefault: 'var(--product-cfr-default)',
  },
  gradient: {
    finStop1: 'var(--gradient-fin-stop-1)',
    finStop2: 'var(--gradient-fin-stop-2)',
    cfrStop1: 'var(--gradient-cfr-stop-1)',
    cfrStop2: 'var(--gradient-cfr-stop-2)',
    alcStop1: 'var(--gradient-alc-stop-1)',
    alcStop2: 'var(--gradient-alc-stop-2)',
    drsStop1: 'var(--gradient-drs-stop-1)',
    drsStop2: 'var(--gradient-drs-stop-2)',
    vdrStop1: 'var(--gradient-vdr-stop-1)',
    vdrStop2: 'var(--gradient-vdr-stop-2)',
    invStop1: 'var(--gradient-inv-stop-1)',
    invStop2: 'var(--gradient-inv-stop-2)',
    losStop1: 'var(--gradient-los-stop-1)',
    losStop2: 'var(--gradient-los-stop-2)',
    orbStop1: 'var(--gradient-orb-stop-1)',
    orbStop2: 'var(--gradient-orb-stop-2)',
    resStop1: 'var(--gradient-res-stop-1)',
    resStop2: 'var(--gradient-res-stop-2)',
    vrsStop1: 'var(--gradient-vrs-stop-1)',
    vrsStop2: 'var(--gradient-vrs-stop-2)',
    '17gStop1': 'var(--gradient-17g-stop-1)',
    '17gStop2': 'var(--gradient-17g-stop-2)',
    evcStop1: 'var(--gradient-evc-stop-1)',
    evcStop2: 'var(--gradient-evc-stop-2)',
    absStop1: 'var(--gradient-abs-stop-1)',
    absStop2: 'var(--gradient-abs-stop-2)',
    hycStop1: 'var(--gradient-hyc-stop-1)',
    hycStop2: 'var(--gradient-hyc-stop-2)',
    igcStop1: 'var(--gradient-igc-stop-1)',
    igcStop2: 'var(--gradient-igc-stop-2)',
    hycIgcStop1: 'var(--gradient-hyc-igc-stop-1)',
    hycIgcStop2: 'var(--gradient-hyc-igc-stop-2)',
    emStop1: 'var(--gradient-em-stop-1)',
    emStop2: 'var(--gradient-em-stop-2)',
    commonStop1: 'var(--gradient-common-stop-1)',
    commonStop2: 'var(--gradient-common-stop-2)',
  },
  other: {
    fileTypeStaging: 'var(--other-file-type-staging)',
    fileTypeFolder: 'var(--other-file-type-folder)',
    fileTypeXls: 'var(--other-file-type-xls)',
    fileTypePng: 'var(--other-file-type-png)',
    fileTypePdf: 'var(--other-file-type-pdf)',
    fileTypeImage: 'var(--other-file-type-image)',
    fileTypeVideo: 'var(--other-file-type-video)',
    fileTypeDoc: 'var(--other-file-type-doc)',
    fileTypePpt: 'var(--other-file-type-ppt)',
    fileTypeArchive: 'var(--other-file-type-archive)',
    fileTypeAudio: 'var(--other-file-type-audio)',
    fileTypeCsv: 'var(--other-file-type-csv)',
    accountTypeAssetManager10b35b: 'var(--other-account-type-asset-manager-10b-35b)',
    accountTypeBrokerDealer: 'var(--other-account-type-broker-dealer)',
    accountTypePrivateEquity: 'var(--other-account-type-private-equity)',
    accountTypeBankDepository: 'var(--other-account-type-bank-depository)',
    accountTypeHedgeFund: 'var(--other-account-type-hedge-fund)',
    accountTypePensionFund: 'var(--other-account-type-pension-fund)',
    accountTypeInsuranceCompany: 'var(--other-account-type-insurance-company)',
    accountTypeFamilyOffice: 'var(--other-account-type-family-office)',
    accountTypeCorporate: 'var(--other-account-type-corporate)',
    accountTypeBrokerDealer5: 'var(--other-account-type-broker-dealer-5)',
    accountTypeMutualFund: 'var(--other-account-type-mutual-fund)',
    accountTypeGovernmentAgency: 'var(--other-account-type-government-agency)',
    industryCommunicationMedia: 'var(--other-industry-communication-media)',
    industryConsumerDiscretionary: 'var(--other-industry-consumer-discretionary)',
    industryConsumerStaples: 'var(--other-industry-consumer-staples)',
    industryInformationTechnology: 'var(--other-industry-information-technology)',
    industryEnergy: 'var(--other-industry-energy)',
    industryFinancials: 'var(--other-industry-financials)',
    industryGovernment: 'var(--other-industry-government)',
    industryHealthCare: 'var(--other-industry-health-care)',
    industryIndustrials: 'var(--other-industry-industrials)',
    industryMaterials: 'var(--other-industry-materials)',
    industryRealEstate: 'var(--other-industry-real-estate)',
    industryUtilities: 'var(--other-industry-utilities)',
    sectorAuto: 'var(--other-sector-auto)',
    sectorCmbs: 'var(--other-sector-cmbs)',
    sectorCollateralizedLoansClos: 'var(--other-sector-collateralized-loans-clos)',
    sectorCreditCard: 'var(--other-sector-credit-card)',
    sectorEquipment: 'var(--other-sector-equipment)',
    sectorEsoteric: 'var(--other-sector-esoteric)',
    sectorRmbs: 'var(--other-sector-rmbs)',
    sectorStudentLoan: 'var(--other-sector-student-loan)',
    sectorConsumerLoans: 'var(--other-sector-consumer-loans)',
    sectorPrivate: 'var(--other-sector-private)',
    sectorAircraftReceivables: 'var(--other-sector-aircraft-receivables)',
    sectorAgency: 'var(--other-sector-agency)',
    countryUnitedStates: 'var(--other-country-united-states)',
    countryUnitedKingdom: 'var(--other-country-united-kingdom)',
    countryBrazil: 'var(--other-country-brazil)',
    countryCanada: 'var(--other-country-canada)',
    countryHongKong: 'var(--other-country-hong-kong)',
    countryLuxembourg: 'var(--other-country-luxembourg)',
    countrySwitzerland: 'var(--other-country-switzerland)',
    countryGermany: 'var(--other-country-germany)',
    countrySingapore: 'var(--other-country-singapore)',
    countryFrance: 'var(--other-country-france)',
    countryItaly: 'var(--other-country-italy)',
    countrySpain: 'var(--other-country-spain)',
    currencyUsDollar: 'var(--other-currency-us-dollar)',
    currencyEuro: 'var(--other-currency-euro)',
    currencyJapaneseYen: 'var(--other-currency-japanese-yen)',
    currencyGreatBritainPound: 'var(--other-currency-great-britain-pound)',
    currencyAustralianDollar: 'var(--other-currency-australian-dollar)',
    currencyCanadianDollar: 'var(--other-currency-canadian-dollar)',
    currencySwissFranc: 'var(--other-currency-swiss-franc)',
    currencyChineseYuan: 'var(--other-currency-chinese-yuan)',
    currencyHongKongDollar: 'var(--other-currency-hong-kong-dollar)',
    currencyNewZealandDollar: 'var(--other-currency-new-zealand-dollar)',
    currencyIndianRupee: 'var(--other-currency-indian-rupee)',
    currencyTurkishLira: 'var(--other-currency-turkish-lira)',
    dealerBam: 'var(--other-dealer-bam)',
    dealerBmo: 'var(--other-dealer-bmo)',
    dealerBnp: 'var(--other-dealer-bnp)',
    dealerBrc: 'var(--other-dealer-brc)',
    dealerDeu: 'var(--other-dealer-deu)',
    dealerGsc: 'var(--other-dealer-gsc)',
    dealerJpm: 'var(--other-dealer-jpm)',
    dealerMos: 'var(--other-dealer-mos)',
    dealerMuf: 'var(--other-dealer-muf)',
    dealerRbc: 'var(--other-dealer-rbc)',
    dealerSoc: 'var(--other-dealer-soc)',
    dealerWfs: 'var(--other-dealer-wfs)',
  },
} as const;

export type TokenCategory = keyof typeof TOKENS;
